module.exports = __webpack_public_path__ + "img/Morbida_island_treasure.930307b1.png";